import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";

export default function Usersearch() {
  const [userGrid, setUserGrid] = useState([]);
  const [selparam, setSelParam] = useState([]);
  let navUserAdd = useNavigate();

  useEffect(() => {
    const getAllUsers = async () => {
      const resUsers = await fetch(
        `${API_BASE_URL}GetAllUsers.php/`
      );
      const resuserjson = await resUsers.json();
      setUserGrid(await resuserjson.data);
    };
    getAllUsers();
  }, []);

  const [userColsDef, setUserColsDef] = useState([
    {
      field: "user_name",
      width: 80,
      headerName: "Edit",
      cellRenderer: (params) => (
        <div>
          <i
            className="icon fas fa-edit"
            title="Edit"
            onClick={() => handleAddClick(params.data.user_name)}
          />
        </div>
      ),
      filter: false,
    },
    {
      field: "user_name",
      width: 150,
      headerName: "User Name",
    },
    {
      field: "title",
      width: 100,
      headerName: "Title",
    },
    {
      field: "f_name",
      width: 250,
      headerName: "Name",
    },
    {
      field: "l_name",
      width: 150,
      headerName: "Last Name",
    },
    {
      field: "role_name",
      width: 200,
      headerName: "Role",
    },
    {
      field: "desig_name",
      width: 200,
      headerName: "Designation",
    },
    {
      field: "mobile_num",
      width: 150,
      headerName: "Mobile",
    },
  ]);
  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    filter: true, // Enable filtering on all columns
  }));
  const handleAddClick = (strUserName) => {
    console.log(strUserName);
    if (strUserName !==""){
      sessionStorage.setItem("edit_user_name", strUserName);
    } else{
      sessionStorage.removeItem("edit_user_name");
    }
    
    navUserAdd("/useradd");
  };

  return (
    <div>
      <div
        className="ag-theme-quartz"
        style={{
          width: "80%", //userGrid ? "80%" : 600,
          height: 600,
          marginLeft: "10%",
          marginTop: "3%",
        }}
      >
        <div style={{ borderBottom: true, alignItems: "right" }}>
          <div>
            <ul class="breadcrumb">
              <li className="breadcrumb-item"><i className="icon fas fa-users"></i>&nbsp;&nbsp;User</li>
              <li className="breadcrumb-item"><i className="icon fas fa-search"></i>&nbsp;&nbsp;Search</li>
            </ul>
          </div>

          <button
            className="btn btn-primary"
            type="button"
            onClick={() => handleAddClick("")}
          >
            Add
          </button>
        </div>
        <div>&nbsp;</div>
        <AgGridReact
          rowData={userGrid}
          columnDefs={userColsDef}
          pagination={true}
          defaultColDef={defaultColDef}
        />
      </div>
    </div>
  );
}
